import httpClient from "../Core/http";
import axios, { AxiosError } from "axios";

class Api {
  getEvents(params: any): Promise<any> {
    let url = "events/serviceReports";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
       //   console.log(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  getEvent(params: any): Promise<any> {
    let url = "events/serviceReport";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        //  console.log(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  getEventEntries(params: any, signal: any): Promise<any> {
    let url = "events/eventEntries";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        //  console.log(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  createServiceReportPdf(params: any): Promise<any> {
    let url = "https://esko-petaja.jsreportonline.net/api/report";
    const headers: any = {
      Authorization: "Basic ZXNrby5wZXRhamFAcHJpbWFwb3dlci5jb206RmxlZXQ5OTk=",
      "Content-Type": "application/json",
      Accept: "application/pdf",
    };
    return axios
      .post(url, params, { responseType: "arraybuffer", headers: headers })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject();
      });
  }
}

export const EventsApi = new Api();
